const CITY_SET = 'EXPERIENCE_CITY_SET';
const CITY_SET_VALIDATION_MESSAGE = 'EXPERIENCE_CITY_SET_VALIDATION_MESSAGE';
const CITY_SET_VISUALIZATION = 'EXPERIENCE_CITY_SET_VISUALIZATION';
const CITY_SET_API_ERROR = 'EXPERIENCE_CITY_SET_API_ERROR';
const CITY_SET_FOCUS = 'EXPERIENCE_CITY_SET_FOCUS';
const CITY_BLURRED = 'EXPERIENCE_CITY_BLURRED';
const CITY_FOCUSED = 'EXPERIENCE_CITY_FOCUSED';
const CITY_CHANGE = 'EXPERIENCE_CITY_CHANGE';
const CITY_RESET_SUGGESTIONS = 'EXPERIENCE_CITY_RESET_SUGGESTIONS';
const CITY_GET_SUGGESTIONS = 'EXPERIENCE_CITY_GET_SUGGESTIONS';
const CITY_SET_SUGGESTIONS = 'EXPERIENCE_CITY_SET_SUGGESTIONS';
const CITY_SUGGESTIONS_ERROR = 'EXPERIENCE_CITY_SUGGESTIONS_ERROR';

const citySet = (value) => ({
  type: CITY_SET,
  payload: {
    value
  }
});

const citySetValidationMessage = (validationMessage) => ({
  type: CITY_SET_VALIDATION_MESSAGE,
  payload: {
    validationMessage
  }
});

const citySetVisualization = (markedAsWrong) => ({
  type: CITY_SET_VISUALIZATION,
  payload: {
    markedAsWrong
  }
});

const citySetApiError = (payload) => ({
  type: CITY_SET_VISUALIZATION,
  payload
});

const citySetFocus = (focus) => ({
  type: CITY_SET_FOCUS,
  payload: {
    focus
  }
});

const cityBlur = (markedAsWrong, validationMessage) => ({
  type: CITY_BLURRED,
  payload: {
    markedAsWrong, validationMessage
  }
});

const cityFocus = () => ({
  type: CITY_FOCUSED
});

const cityChange = (payload) => ({
  type: CITY_CHANGE,
  payload
});

const citySuggestionsReset = () => ({
  type: CITY_RESET_SUGGESTIONS
});

const citySuggestionsGet = (query, isPoland) => ({
  type: CITY_GET_SUGGESTIONS,
  payload: {
    query,
    isPoland
  }
});

const citySuggestionsSet = (suggestions) => ({
  type: CITY_SET_SUGGESTIONS,
  payload: {
    suggestions
  }
});

const citySuggestionsError = () => ({
  type: CITY_SUGGESTIONS_ERROR
});

export {
  citySetValidationMessage,
  citySetVisualization,
  cityFocus,
  citySetFocus,
  citySetApiError,
  cityBlur,
  citySet,
  cityChange,
  citySuggestionsGet,
  citySuggestionsReset,
  citySuggestionsSet,
  citySuggestionsError,
  CITY_SUGGESTIONS_ERROR,
  CITY_SET_SUGGESTIONS,
  CITY_GET_SUGGESTIONS,
  CITY_RESET_SUGGESTIONS,
  CITY_CHANGE,
  CITY_FOCUSED,
  CITY_BLURRED,
  CITY_SET_FOCUS,
  CITY_SET_API_ERROR,
  CITY_SET_VALIDATION_MESSAGE,
  CITY_SET,
  CITY_SET_VISUALIZATION
};

